import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();
  // State data
  const [isApps, setIsApps] = useState(true); // Apps initially open
  const [isResources, setIsResources] = useState(true); // Resources initially open
  const [isCourses, setIsCourses] = useState(true); // Courses initially open
  const [isSupportTickets, setIsSupportTickets] = useState(true); // Support Tickets initially open
  const [isDemo, setIsDemo] = useState(true); // Demo initially open
  const [isEcommerce, setIsEcommerce] = useState(true); // Ecommerce initially open
  const [isJobs, setIsJobs] = useState(true); // Jobs initially open

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  // Get user role from Redux or localStorage
  const { user } = useSelector(state => ({
    user: state.Login.user,
  }));
  const userRole = user?.role || JSON.parse(localStorage.getItem('user') || '{}')?.role || 'Guest';

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history, iscurrentState]);

  // Full menu items
  const fullMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bx bxs-dashboard",
      link: "/dashboard",
    },
    {
      id: "apps",
      label: "Apps",
      icon: "bx bx-layer",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsApps(!isApps); // Toggle Apps open/close
        setIscurrentState("Apps");
        updateIconSidebar(e);
      },
      stateVariables: isApps,
      subItems: [
        {
          id: "calendar",
          label: "Calendar",
          link: "/apps-calendar",
          parentId: "apps",
        },
        {
          id: "appsecommerce",
          label: "Ecommerce",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsEcommerce(!isEcommerce); // Toggle Ecommerce open/close
          },
          parentId: "apps",
          stateVariables: isEcommerce,
          childItems: [
            {
              id: 1,
              label: "Products",
              link: "/apps-ecommerce-products",
              parentId: "apps",
            },
            {
              id: 2,
              label: "Add Product",
              link: "/apps-ecommerce-add-product",
              parentId: "apps",
            },
            {
              id: 3,
              label: "Orders",
              link: "/apps-ecommerce-orders",
              parentId: "apps",
            },{
              id: 4,
              label: "Clients",
              link: "/apps-ecommerce-clients",
              parentId: "apps",
            },
            {
              id: 5,
              label: "Categories",
              link: "/apps-categories-list",
              parentId: "apps",
            },
          ],
        },
        {
          id: "jobs",
          label: "Jobs",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsJobs(!isJobs); // Toggle Jobs open/close
          },
          parentId: "apps",
          stateVariables: isJobs,
          childItems: [
            {
              id: 1,
              label: "List View",
              link: "/apps-job-lists",
              parentId: "apps",
            },
            {
              id: 2,
              label: "Create Job",
              link: "/apps-job-new",
              parentId: "apps",
            },
          ],
        },
        {
          id: "appsresources",
          label: "Resources",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsResources(!isResources); // Toggle Resources open/close
          },
          parentId: "apps",
          stateVariables: isResources,
          childItems: [
            {
              id: 1,
              label: "List",
              link: "/apps-resource-list",
              parentId: "apps",
            },
            {
              id: 2,
              label: "Create Resource",
              link: "/apps-resource-create",
              parentId: "apps",
            },
          ],
        },
        {
          id: "appscourses",
          label: "Courses",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsCourses(!isCourses); // Toggle Courses open/close
          },
          parentId: "apps",
          stateVariables: isCourses,
          childItems: [
            {
              id: 1,
              label: "List",
              link: "/apps-courses-list",
              parentId: "apps",
            },
            {
              id: 2,
              label: "Create Course",
              link: "/apps-courses-create",
              parentId: "apps",
            },
          ],
        },
        {
          id: "supportTickets",
          label: "Support Tickets",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsSupportTickets(!isSupportTickets); // Toggle Support Tickets open/close
          },
          parentId: "apps",
          stateVariables: isSupportTickets,
          childItems: [
            {
              id: 1,
              label: "List View",
              link: "/apps-tickets-list",
              parentId: "apps",
            },
          ],
        },
        {
          id: "demo",
          label: "Demo",
          link: "/#",
          isChildItem: true,
          click: function (e) {
            e.preventDefault();
            setIsDemo(!isDemo); // Toggle Demo open/close
          },
          parentId: "apps",
          stateVariables: isDemo,
          childItems: [
            {
              id: 1,
              label: "List View",
              link: "/apps-demo-list",
              parentId: "apps",
            },
          ],
        },
      ],
    },

    {
      id: "team",
      label: "Team",
      icon: "bx bx-group",
      link: "/pages-team",
    },
    {
      id: "timeline",
      label: "Timeline",
      icon: "bx bx-time",
      link: "/pages-timeline",
    },
  ];

  const getFilteredMenuItems = () => {
    if (userRole === 'admin') {
      return fullMenuItems;
    }

    if (userRole === 'support') {
      // Support sees Menu header, Dashboard, Apps with Ecommerce > Orders, Support Tickets, and Demo
      return fullMenuItems.filter(item => {
        if (item.isHeader && item.label === 'Menu') return true; // Keep Menu header
        if (item.id === 'dashboard') return true; // Keep Dashboard
        if (item.id === 'apps') {
          return true; // Keep Apps, filter subItems below
        }
        return false; // Exclude Pages header, Team, and Timeline
      }).map(item => {
        if (item.id === 'apps') {
          return {
            ...item,
            subItems: item.subItems.filter(subItem =>
                subItem.id === 'appsecommerce' ||
                subItem.id === 'supportTickets' ||
                subItem.id === 'demo'
            ).map(subItem => {
              if (subItem.id === 'appsecommerce') {
                return {
                  ...subItem,
                  childItems: subItem.childItems.filter(child => child.link === '/apps-ecommerce-orders'),
                };
              }
              return subItem;
            }),
          };
        }
        return item;
      });
    }    if (userRole === 'editor') {
      // Editor sees all except Team, Timeline, and Support Tickets
      return fullMenuItems
          .filter(item => item.isHeader || item.id === 'dashboard' || item.id === 'apps')
          .map(item => {
            if (item.id === 'apps') {
              return {
                ...item,
subItems: item.subItems.filter(subItem => subItem.id !== 'supportTickets' && subItem.id !== 'demo'&& subItem.id!=='calendar'),              };
            }
            return item;
          });
    }

    // Default (Guest or other roles): Only Dashboard
    return fullMenuItems.filter(item => item.isHeader || item.id === 'dashboard');
  };

  const menuItems = getFilteredMenuItems();

  return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;